import { useState } from "react";
import { Sort } from "../../../../../components/@types";
import Grid from "../../../../../components/Grid";
import Title from "../../../../../components/Title";
import { sortGridByColumn } from "../../../../../utils";
import { Signature } from "../../../@types/rldynamicanalysis";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import { RlCloudSandboxSignaturesGridSchema } from "./RlCloudSandboxSignaturesGridSchema";

type RlCloudSandboxSignaturesProps = {
  data: Signature[];
  reportTitle: string;
};

const pageSizes = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "40", value: "40" },
  { label: "100", value: "100" }
];

const RlCloudSandboxSignatures = ({
  data,
  reportTitle
}: RlCloudSandboxSignaturesProps) => {
  const [pageNum, setPageNum] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(20);
  const [sort, setSort] = useState({
    field: "default",
    direction: "asc"
  });

  const pageData =
    data?.slice((pageNum - 1) * currentPageSize, pageNum * currentPageSize) ||
    [];

  const handleSortChange = (sortParams: Sort) => {
    const { field, direction } = sort;
    if (sortParams.direction === direction && sortParams.field === field)
      return;
    setSort(sortParams);
    sortGridByColumn(data, sortParams);
  };

  return (
    <div>
      <Title Level="h2" text={`Signatures (${reportTitle})`} />

      {data?.length ? (
        <Grid
          data={pageData}
          numPages={Math.ceil(data?.length / currentPageSize)}
          schema={RlCloudSandboxSignaturesGridSchema(true)}
          page={pageNum}
          pageSize={currentPageSize}
          totalResults={data?.length || 0}
          showPageNumbers
          onPageChange={(value: number, pageSize: number) => {
            setPageNum(value);
            setCurrentPageSize(pageSize);
          }}
          enablePageSizeSelector
          pageSizeSelectorItems={pageSizes}
          sort={sort}
          onSortChange={handleSortChange}
        />
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.signatures}</b>
      )}
    </div>
  );
};

export default RlCloudSandboxSignatures;
